import { isFeatureEnabled } from "config/features"

/**
 * Returns the ordered list of step IDs for the new wizard.
 * Called at runtime so the feature flag is evaluated fresh each time.
 */
export const getSteps = () => [
  "details",
  "scheduling",
  "media",
  "resources",
  "location",
  ...(isFeatureEnabled("CUSTOM_TEMPLATE") ? ["digital_waiver"] : []),
  "preview"
]

/**
 * AntD form field names that belong to each step.
 * Used for:
 *   1. form.validateFields(STEP_FIELDS[step])  — step-level validation
 *   2. toApiPayload(step, form.getFieldsValue()) — building the request body
 *
 * Media / resources / location / waiver have special state outside the form;
 * their save logic lives in step-registered handlers (stepSaveHandlersRef).
 */
export const STEP_FIELDS = {
  details: [
    "title",
    "description",
    "categories",
    "min_guests",
    "max_guests",
    "languages",
    "skill_levels",
    "included_items",
    "bring_items",
    "accessibility_enabled",
    "alcohol_allowed",
    "children_allowed",
    "publish_on_guides_site",
    "publish_on_platform"
  ],
  scheduling: [
    "pricing_type",
    "deposit_percentage",
    "full_payment_required",
    "licenses_required",
    "licenses_list",
    "seasonal",
    "recurringYearly",
    "available_days",
    "available_hours"
  ],
  media: [],          // validated via mediaFilesRef (min 2 active)
  resources: [],      // optional, no required fields
  location: [],       // special: Google Places + geocoder state, handled by registered save handler
  digital_waiver: [], // optional
  preview: []
}
